<template>
  <div>
    <div class="mb-10 pa-3">
      <info-box :label="$t('rentals.allRentals')" :value="recordCount"></info-box>
    </div>
    <div class="page-body">
      <rentals-table :data="rentals"></rentals-table>
    </div>
  </div>
</template>

<script>
import { RENTAL_STATUS } from '@/libs/enum'
import { RENTALS } from '@/libs/fakeData'
import InfoBox from '@/components/Share/InfoBox'
import RentalsTable from '@/components/Tables/Rentals'

export default {
  components: { InfoBox, RentalsTable },
  data () {
    return {
      data: RENTALS
    }
  },
  computed: {
    rentals () {
      return this.data.filter(record => {
        return RENTAL_STATUS[record.status] === 'returned'
      })
    },
    recordCount () {
      return this.rentals.length
    }
  }
}
</script>
